import { Cog6ToothIcon } from "@heroicons/react/24/solid";
import { cn } from "@moe/priv/utils";
import { useSettingsSidebarContext } from "@web/route-services/chat/settings/SettingsSidebarProvider";
import { motion } from "motion/react";

interface Props {
  className?: string;
}

export const SettingsButton = ({ className }: Props) => {
  const { toggleSidebar } = useSettingsSidebarContext();

  return (
    <motion.button
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.9, rotate: 90 }}
      transition={{ duration: 0.2 }}
      className={cn("focus:outline-none", className)}
      onClick={(e) => {
        e.stopPropagation();
        toggleSidebar();
      }}
    >
      <Cog6ToothIcon className="fill-tx-tertiary active:fill-tx-primary size-7 opacity-80 transition duration-300 ease-out hover:rotate-180 hover:fill-white hover:opacity-60 md:size-8" />
    </motion.button>
  );
};
